export const formatCurrency = (value: string, multiplier = 1) =>
  Math.round(Number.parseFloat(value) * multiplier).toLocaleString('sv-SE');
